import { urlPlugin } from "./url-plugin";
import { importPlugin } from "./import-plugin";
import { localFilePlugin } from "./local-file-plugin";
import { localFolderPlugin } from "./local-folder-plugin";
import { zoteroPlugin } from "./zotero-plugin";
import { UploadPlugin } from "./plugin-interface";

export const BUILTIN_PLUGINS: Record<string, UploadPlugin> = {
  url: urlPlugin,
  import: importPlugin,
  "local-file": localFilePlugin,
  "local-folder": localFolderPlugin,
  zotero: zoteroPlugin,
};
